import loginActions from '../actionTypes/loginActions';
import getAction from './sharedActionCreators';

export const userLogin = payload => {
  return getAction(loginActions.userLogin, payload);
};

export const setCurrentUser = currentUser => {
  return getAction(loginActions.setCurrentUser, currentUser);
};

export const setMealTypes = mealTypes => {
  return getAction(loginActions.setMealTypes, mealTypes);
};

export const logoutUser = () => getAction(loginActions.logoutUser);
